export default "__VITE_ASSET__Gwv0EyIE__"